import React from 'react';
import styled from 'styled-components';

const WizardPaso1 = () => {
  return (
    <FaseContainer>
      <PasoInicial>
        <LineaCorta completado />
        <Circulo completado />
      </PasoInicial>
      <PasoMitad>
        <LineaIzquierda completado />
        <LineaDerecha />
        <Circulo />
      </PasoMitad>
      <Paso>
        <Circulo />
      </Paso>
      <Paso>
        <Circulo />
      </Paso>
      <Paso>
        <Circulo />
      </Paso>
      <PasoFinal>
        <LineaCorta />
      </PasoFinal>
    </FaseContainer>
  );
};

const FaseContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`;

const Paso = styled.div`
  flex: 1;
  height: 4px;
  background-color: #d3d3d3;
  position: relative;
`;

const PasoInicial = styled(Paso)`
  flex: 0.5;
`;

const PasoMitad = styled(Paso)`
  display: flex;
`;

const PasoFinal = styled(Paso)`
  flex: 0.5;
`;

const LineaCorta = styled.div`
  width: 100%;
  height: 4px;
  background-color: ${props => props.completado ? '#005a78' : '#d3d3d3'};
`;

const LineaIzquierda = styled.div`
  flex: 1;
  height: 4px;
  background-color: #005a78;
`;

const LineaDerecha = styled.div`
  flex: 1;
  height: 4px;
  background-color: #d3d3d3;
`;

const Circulo = styled.div`
  width: 15px;
  height: 15px;
  background-color: ${props => props.completado ? '#005a78' : '#d3d3d3'};
  border-radius: 50%;
  position: absolute;
  left: calc(100% - 7.5px);
  top: -5.5px;
  z-index: 1;
`;

export default WizardPaso1;